const PrioritiesChallenge1InitialText ="Drag and drop the items to prioritize the purchases. " + 
    "You don't need to consider the dollar amount of items as part of this prioritization. " +
    "When you believe that you have them in the right order, click the 'Done' button."
export default PrioritiesChallenge1InitialText